<div class="load__animation" *ngIf="showAnimation$ | async">
  <img src="assets/animations/animation-load.svg" alt="" />
</div>

<div class="forgot-password-page" *ngIf="!(showAnimation$ | async)">
  <div class="forgot-password-page__image"></div>
  <div class="forgot-password-page__form">
    <div class="form-container" [formGroup]="forgotPasswordForm" [@errorFormAnimation]="forgotPasswordError">
      <div class="logo-section">
        <div class="logo"></div>
        <div class="sub-logo">{{ 'SERVICE_PORTAL' | translate }}</div>
      </div>

      <div class="header-section">
        {{ 'RESET_PASSWORD' | translate }}
      </div>

      <!-- Request Link Fields-->
      <div *ngIf="!forgotPasswordToken">
        <div *ngIf="!(forgotPasswordRequestLinkSuccess$ | async)">
          <div class="inputs-section">
            <div class="email">
              <app-input
                formControlName="email"
                [control]="email"
                [isInvalid]="!!email.errors && !email.pristine"
                [label]="'EMAIL_LABEL' | translate"
                [isServerError]="isServerError"
                [placeholder]="'EMAIL_PLACEHOLDER' | translate"
              >
              </app-input>
            </div>
          </div>

          <div class="button-section">
            <app-button
              (triggered)="handleCaptcha()"
              *ngIf="!(forgotPasswordRequestLinkLoading$ | async)"
              [size]="'large'"
              [filled]="true"
              [disabled]="forgotPasswordForm.invalid"
            >
              {{ 'SEND_RESET_LINK' | translate }}
            </app-button>
            <div class="load__animation" *ngIf="forgotPasswordRequestLinkLoading$ | async">
              <img src="assets/animations/animation-load.svg" alt="" />
            </div>
          </div>
        </div>

        <div *ngIf="forgotPasswordRequestLinkSuccess$ | async">
          <div class="inputs-section">
            <div>{{ 'RESET_PASSWORD_LINK_SENT' | translate }}</div>
          </div>

          <div class="button-section">
            <a class="login" routerLink="/login">{{ 'LOG_IN' | translate }}</a>
          </div>
        </div>
      </div>

      <!-- Request Reset Fields-->
      <div *ngIf="forgotPasswordToken">
        <div *ngIf="!(forgotPasswordRequestResetSuccess$ | async)">
          <div class="inputs-section">
            <div class="password">
              <app-input
                formControlName="password"
                [control]="password"
                [label]="'PASSWORD_LABEL' | translate"
                [type]="'password'"
                [isInvalid]="!!password.errors && !password.pristine"
                [isPassword]="true"
                [placeholder]="'PASSWORD_PLACEHOLDER' | translate"
              >
              </app-input>
            </div>
          </div>

          <div class="button-section">
            <app-button
              (triggered)="handleCaptcha()"
              *ngIf="!(forgotPasswordRequestResetLoading$ | async)"
              [size]="'large'"
              [filled]="true"
              [disabled]="forgotPasswordForm.invalid"
            >
              {{ 'RESET_PASSWORD' | translate }}
            </app-button>
            <div class="load__animation" *ngIf="forgotPasswordRequestResetLoading$ | async">
              <img src="assets/animations/animation-load.svg" alt="" />
            </div>
          </div>
        </div>

        <div *ngIf="forgotPasswordRequestResetSuccess$ | async">
          <div class="inputs-section">
            <div>{{ 'RESET_PASSWORD_SUCCESS' | translate }}</div>
          </div>

          <div class="button-section">
            <a class="login" routerLink="/login">{{ 'LOG_IN' | translate }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="version">v{{ appVersion }}</div>
  </div>
</div>

<ngx-invisible-recaptcha
  *ngIf="!(isDone$ | async)"
  #captchaElem
  [siteKey]="siteKey"
  (success)="handleSuccess($event)"
  (expire)="handleExpire()"
  (error)="handleError()"
  [ngModel]="recaptcha"
  [ngModelOptions]="{ standalone: true }"
>
</ngx-invisible-recaptcha>
